type Props = {
  className?: string;
  value: any;
};

export const RiderNameCellElem = ({ className, value }: Props) => {
  return <td className={className ?? ''}>{value}</td>;
};
